import { render, staticRenderFns } from "./InventoryTransfer.vue?vue&type=template&id=2406db44&"
import script from "./InventoryTransfer.vue?vue&type=script&lang=js&"
export * from "./InventoryTransfer.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports